var map = {
	"./google-play-badge-da-DK.svg": 33494,
	"./google-play-badge-de-DE.svg": 62660,
	"./google-play-badge-en-GB.svg": 19870,
	"./google-play-badge-en-US.svg": 76597,
	"./google-play-badge-es-ES.svg": 60974,
	"./google-play-badge-es-MX.svg": 13517,
	"./google-play-badge-fr-FR.svg": 41294,
	"./google-play-badge-it-IT.svg": 66348,
	"./google-play-badge-nb-NO.svg": 65491,
	"./google-play-badge-nl-NL.svg": 40714,
	"./google-play-badge-pl-PL.svg": 25922,
	"./google-play-badge-pt-BR.svg": 21102,
	"./google-play-badge-pt-PT.svg": 49826,
	"./google-play-badge-sv-SE.svg": 40911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;